import React, { useState } from 'react'
import {
  FieldErrorAndDescription,
  FieldErrorAndDescriptionProps,
} from 'shared/components/form/field-error-and-description'
import { FieldLabel, FieldLabelProps } from 'shared/components/form/field-label'
import { EyeIcon } from '@systemeio/ui/icons'

type InputProps = React.InputHTMLAttributes<HTMLInputElement> &
  FieldLabelProps &
  FieldErrorAndDescriptionProps

function FormInputPassword({
  label,
  labelClassName,
  value,
  onChange,
  autoComplete,
  id,
  onFocus,
  maxLength,
  error,
  placeholder,
  required,
  description,
  className,
  ...rest
}: InputProps) {
  const [isPasswordShown, setIsPasswordShown] = useState(false)
  return (
    <label className={`relative flex flex-col gap-1 text-sm font-medium ${className || ''}`}>
      <FieldLabel label={label} labelClassName={labelClassName} required={required} />
      <EyeIcon
        className={`z-1 absolute right-2 h-[21px] w-[21px] translate-y-1/2 scale-75 cursor-pointer ${
          label && 'top-[24px]'
        } ${isPasswordShown ? 'fill-brand-primary' : 'fill-fill-primary'}`}
        onClick={() => setIsPasswordShown(!isPasswordShown)}
      />
      <input
        className={`text-text-primary main-transition-colors w-full rounded-lg border ${
          error ? 'border-danger' : 'border-text-secondary/30'
        } focus:border-brand-primary placeholder:text-text-tertiary/70 py-2.5 pl-4 pr-8 focus:outline-hidden`}
        type={isPasswordShown ? 'text' : 'password'}
        autoComplete={autoComplete}
        id={id}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        maxLength={maxLength}
        placeholder={placeholder}
        spellCheck={false}
        disabled={rest.disabled}
      />
      <FieldErrorAndDescription description={description} error={error} />
    </label>
  )
}

export default FormInputPassword
